import { Predicate } from './functions'

export const createPropertyKeyArray = (
  arr: ReadonlyArray<PropertyKey>,
): ReadonlyArray<PropertyKey> => arr

export const notProp =
  (...notProps: ReadonlyArray<PropertyKey>): Predicate<PropertyKey> =>
  (prop) =>
    !createPropertyKeyArray(notProps).includes(prop)
